export const ADD_TOAST_NOTIFICATION = 'NOTIFICATIONS/ADD_TOAST';
export const ENQUEUE_NOTIFICATION_TOAST = 'NOTIFICATIONS/ENQUEUE_TOAST';
export const DEQUEUE_NOTIFICATION_TOAST = 'NOTIFICATIONS/DEQUEUE_TOAST';
